import React from 'react'

const Recipes = () => {
  return (
    <div>
      < a href='./Recipes'>Recipes</a>
    </div>
  )
}

export default Recipes
